import * as Yup from "yup"

const re =
  /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm

export const applyFormValidation = Yup.object({
  user_fullname: Yup.string()
    .required("*Nama lengkap wajib diisi")
    .min(3, "Nama minimal 3 karakter")
    .matches(/^[a-zA-Z\s]*$/, "Tidak boleh ada angka"),
  user_email: Yup.string().email("Email tidak valid").required("*Email wajib diisi"),
  user_phone_number: Yup.string()
    .required("*Nomor whatsapp wajib diisi")
    .min(12, "Pastikan kode negara di pilih, dan nomor telepon minimal 10 karakter")
    .max(15, "Nomor telepon maksimal 13 karakter"),
  user_linkedin: Yup.string()
    .matches(/www.linkedin.com/gm, "Format yang kamu masukan salah")
    .required("*Link linkedin wajib diisi"),
  user_portfolio_link: Yup.string()
    .required("*Link protofolio wajib diisi")
    .matches(re, "*URL tidak valid"),
  user_university: Yup.string()
    .required("*Nama universitas wajib diisi")
    .min(3, "*Minimal 3 karakter")
    .matches(/^[a-zA-Z\d\s:]*$/, "Nama universitas hanya diperbolehkan kombinasi angka dan huruf")
    .required("*Asal universitas wajib diisi"),
  user_city: Yup.string().required("*Domisili wajib diisi"),
  user_activities: Yup.array().compact().min(1, "*Pilih minimal satu").required("*Wajib diisi"),
  user_description: Yup.string()
    .min(15, "Minimal 15 Karakter")
    .max(500, "Maksimal 500 Karakter")
    .required("*Deskripsi diri wajib diisi"),
  user_expected_salary: Yup.array()
    .compact()
    .min(1, "*Pilih minimal satu")
    .required("*Wajib diisi"),
  job_question_answer: Yup.object({
    other_question_1: Yup.string()
      .min(5, "Minimal 5 Karakter")
      .max(500, "Maksimal 500 Karakter")
      .required("*Wajib diisi"),
    other_question_2: Yup.string()
      .min(5, "Minimal 5 Karakter")
      .max(500, "Maksimal 500 Karakter")
      .required("*Wajib diisi"),
    other_question_3: Yup.string()
      .min(5, "Minimal 5 Karakter")
      .max(500, "Maksimal 500 Karakter")
      .required("*Wajib diisi"),
    other_question_4: Yup.string()
      .min(5, "Minimal 5 Karakter")
      .max(500, "Maksimal 500 Karakter")
      .required("*Wajib diisi"),
  }),

  // user_achievement: Yup.string()
  //   .min(5, "Minimal 5 Karakter")
  //   .max(500, "Maksimal 500 Karakter")
  //   .required("*URL wajib diisi"),
  // user_expectation: Yup.string()
  //   .min(5, "Minimal 5 Karakter")
  //   .max(500, "Maksimal 500 Karakter")
  //   .required("*URL wajib diisi"),
  // user_contribution: Yup.string()
  //   .min(5, "Minimal 5 Karakter")
  //   .max(500, "Maksimal 500 Karakter")
  //   .required("*URL wajib diisi"),
  // user_commitment: Yup.string()
  //   .min(5, "Minimal 5 Karakter")
  //   .max(500, "Maksimal 500 Karakter")
  //   .required("*URL wajib diisi"),
  user_skills: Yup.array()
    .of(Yup.string().min(1, "*Wajib diisi"))
    .min(1, "*Pilih minimal satu")
    .max(5, "*Pilih maksimal 5 skills")
    .required("*Wajib diisi"),
  user_skill_tools: Yup.array()
    .min(1, "*Pilih minimal satu")
    .max(3, "*Pilih maksimal 3 tools")
    .required("*Wajib diisi"),
  // expected_salaries: Yup.array().min(1, "*Pilih minimal satu").required("*Wajib diisi"),
})

export const poolFormValidation = Yup.object({
  category_id: Yup.string().required("*Tim wajib diisi"),
  career_position_id: Yup.string().required("*Posisi wajib diisi"),
  user_fullname: Yup.string()
    .required("*Nama lengkap wajib diisi")
    .min(3, "Nama minimal 3 karakter")
    .matches(/^[a-zA-Z\s]*$/, "Tidak boleh ada angka"),
  user_email: Yup.string().email("Email tidak valid").required("*Email wajib diisi"),
  user_phone_number: Yup.string()
    .required("*Nomor whatsapp wajib diisi")
    .min(12, "Pastikan kode negara di pilih, dan nomor telepon minimal 10 karakter")
    .max(15, "Nomor telepon maksimal 13 karakter"),
  user_linkedin: Yup.string()
    .matches(/www.linkedin.com/gm, "Format yang kamu masukan salah")
    .required("*URL wajib diisi"),
  user_portfolio_link: Yup.string().required("*URL wajib diisi").matches(re, "*URL tidak valid"),
  user_university: Yup.string()
    .required("*Nama universitas wajib diisi")
    .min(3, "*Minimal 3 karakter")
    .matches(/^[a-zA-Z\d\s:]*$/, "Nama universitas hanya diperbolehkan kombinasi angka dan huruf")
    .required("*Asal universitas wajib diisi"),
  user_city: Yup.string().required("*Domisili wajib diisi"),
  user_activities: Yup.array().compact().min(1, "*Pilih minimal satu").required("*Wajib diisi"),
  user_description: Yup.string()
    .min(15, "Minimal 15 Karakter")
    .max(500, "Maksimal 500 Karakter")
    .required("*Deskripsi diri wajib diisi"),
  user_expected_salary: Yup.array()
    .compact()
    .min(1, "*Pilih minimal satu")
    .required("*Wajib diisi"),
  job_question_answer: Yup.object({
    other_question_1: Yup.string()
      .min(5, "Minimal 5 Karakter")
      .max(500, "Maksimal 500 Karakter")
      .required("*Wajib diisi"),
    other_question_2: Yup.string()
      .min(5, "Minimal 5 Karakter")
      .max(500, "Maksimal 500 Karakter")
      .required("*Wajib diisi"),
    other_question_3: Yup.string()
      .min(5, "Minimal 5 Karakter")
      .max(500, "Maksimal 500 Karakter")
      .required("*Wajib diisi"),
    other_question_4: Yup.string()
      .min(5, "Minimal 5 Karakter")
      .max(500, "Maksimal 500 Karakter")
      .required("*Wajib diisi"),
  }),

  user_skills: Yup.array()
    .min(1, "*Pilih minimal satu")
    .max(5, "*Pilih maksimal 5 skills")
    .required("*Wajib diisi"),
  user_skill_tools: Yup.array()
    .min(1, "*Pilih minimal satu")
    .max(3, "*Pilih maksimal 3 tools")
    .required("*Wajib diisi"),

  user_job_system: Yup.string().required("*Sistem kerja wajib diisi"),
  user_job_type: Yup.string().required("*Tipe kerja wajib diisi"),
})
